<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<a id="page3"></a>
<p class="center2">To my three darling sisters:</p>
<p class="center">Lols, Megs and Sammy-Lamb.</p>
<p class="center">and my amazing Mom.</p>
<p class="center">Thank you for all the love, laughter and not to forget, the drama!</p>
<p class="center">What family is complete without it?</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?3af0a34c